import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { BoltFillIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { handleContactSalesClick } from '../utils';
export const BizInquiry = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  const {
    locale
  } = useLocale();
  return <section className="flex flex-col items-center px-md pb-4xl pt-3xl" data-sentry-component="BizInquiry" data-sentry-source-file="BizInquiry.tsx">
      <div className="flex flex-col items-center gap-2xl">
        <h2 className="text-center text-heading-xl-extrabold text-default">
          {t('biz-landing.inquiry.title')}
        </h2>
        <Button variant="contained" intent="gradient" size="lg" className="w-[372px]" leftSlot={<BoltFillIcon size="md" />} onClick={() => handleContactSalesClick(locale)} data-sentry-element="Button" data-sentry-source-file="BizInquiry.tsx">
          {t('biz-landing.plan.enterprise.button')}
        </Button>
      </div>
    </section>;
};